import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/lib/Async'
import moment from '../../../helpers/moment'
import "react-datepicker/dist/react-datepicker.css"
import PoolApi from '../../../api/pools'
import MomentDatePicker from '../../../components/momentDatePicker'
import { adjustScheduleStartTime } from '../../../actions/restaurantPoolSchedule'
import { getDefaultTimezone } from '../../../actions/system'

export class PoolScheduleEditor extends React.Component {

  constructor(props){
    super()
    this.state = {
      poolSchedule: props.poolSchedule,
      selectedStartDate : null,
      selectedStartDateMoment : null,
      selectedPool : null
    }
  }
  getRestaurantTimeZone(timeZonedObj){

    // if a pool is selected use the selected pool as the timezone
    if (timeZonedObj && timeZonedObj.timeZone){
      return timeZonedObj.timeZone
    }

    // if we have a timezone on our other pool we will use that
    let stateRowsWithTimeZone = this.state.poolSchedule.filter(row=>row.pool && row.pool.timeZone)
    if(stateRowsWithTimeZone.length > 0){
      return stateRowsWithTimeZone[stateRowsWithTimeZone.length-1].pool.timeZone
    }

    // fallback to UTC timezone
    return this.props.defaultTimeZone || "ETC/UTC"
  }

  scheduleRowSort(row1, row2){
    return moment.utc(row1.startDateUtc) - moment.utc(row2.startDateUtc)
  }

  getPoolOptions(searchText){
    return PoolApi.Summary({pool:searchText, sortField: 'name', sortDirection: 'asc', itemsPerPage: 25})
      .then(response => response.json())
      .then(response => response.data.map(datum => ({ label: datum.name, value: datum.id, timeZone:datum.timeZone})))
      .then(response => [{ label: 'No pool', value: null}].concat(response))
  }


  removeScheduleRow(rowToRemove){
    let newSchedule = this.props.poolSchedule
      .filter(ps=>ps !== rowToRemove)
      .sort(this.scheduleRowSort)
    this.props.onPoolScheduleChange(newSchedule)
  }

  addScheduleRow(){
    let pool = this.state.selectedPool.value == null ? null : {
      id: this.state.selectedPool.value,
      name: this.state.selectedPool.label,
      timeZone:  this.state.selectedPool.timeZone
    }

    let startDateUtc = this.state.selectedStartDateMoment.format()

    let rowToAdd = {
      pool: pool,
      startDateUtc: startDateUtc
    }

    let newSchedule = this.props.poolSchedule
      .concat([rowToAdd])
      .sort(this.scheduleRowSort)
    this.setState({
      selectedStartDateMoment: null,
      selectedPool: null
    })
    this.props.onPoolScheduleChange(newSchedule)
  }

  canAddScheduleRow(){
    return !this.props.disabled
      && this.state.selectedPool != null
      && this.state.selectedStartDateMoment != null
      && this.state.selectedStartDateMoment.isValid()
      && this.state.selectedStartDateMoment.isAfter(this.minStartMoment(this.state.selectedPool))
      && this.state.selectedStartDateMoment.isBefore(this.minStartMoment(this.state.selectedPool).add(1, 'year'))
  }

  canRemoveScheduleRow(scheduleRow){
    let poolIsEqual = (pool1, pool2) => pool1 === pool2 || (pool1 && pool2 && pool1.id === pool2.id)

    let isSaved = this.props.savedPoolSchedule && this.props.savedPoolSchedule.some(savedSechdule => savedSechdule.startDateUtc === scheduleRow.startDateUtc
      && poolIsEqual(savedSechdule.pool, scheduleRow.pool))

    // we will allow them to remove dates they have added but now saved, or that are in the future
    return !isSaved || moment.utc(scheduleRow.startDateUtc).isAfter(moment.utc())
  }

  minStartMoment(pool){
    let timeZone = pool && pool.timeZone
      ? pool.timeZone
      : this.getRestaurantTimeZone()

    return moment.tz(timeZone).startOf('day')
  }

  render() {
    return <div className="row">
      <div className="col-lg-6 col-sm-12">
        {this.props.poolSchedule.length === 0
          ?
          <div className="alert alert-info">This restaurant is not scheduled for any pool</div>
          : <table className="table table-striped">
            <tbody>
              {this.props.poolSchedule.map(scheduleRow=>{
                let startTime = moment.parseZone(scheduleRow.startDateUtc)
                return <tr key={scheduleRow.startDateUtc}>
                  <td className="align-middle">{scheduleRow.pool ? <a href={"/pools/" + scheduleRow.pool.id}>{scheduleRow.pool.name}</a> : <span>No pool</span> }</td>
                  <td className="align-middle">on <abbr title={startTime.format("dddd, MMMM Do YYYY, HH:mm:ss ([GMT]Z)")}>{startTime.format("DD-MMM-YYYY")}</abbr></td>
                  <td className="align-middle text-center">
                    { this.props.isEditing && this.canRemoveScheduleRow(scheduleRow)
                      ? <button className="btnRemove btn btn-sm btn-primary" onClick={() => this.removeScheduleRow(scheduleRow)} disabled={this.props.disabled}>Remove</button>
                      : null
                    }
                  </td>
                </tr>
              })}
            </tbody>
          </table>}
      </div>

      {!this.props.isEditing ? null :
        <div className="col-lg-6 col-sm-12">

          <h4 className="col-sm-12">Schedule a change</h4>

          <div className="input-group input-group-sm mb-3">
            <div className="col-sm-5">
              <AsyncSelect
                id="selectPoolInput"
                classNamePrefix="selectPoolInput"
                placeholder="Pool"
                disabled={this.props.disabled}
                cacheOptions
                defaultOptions
                onChange={(selected)=>this.setState({selectedPool: selected, selectedStartDateMoment: null})}
                value={this.state.selectedPool}
                loadOptions={this.getPoolOptions.bind(this)} />
            </div>
            <div className="col-sm-5">
              <MomentDatePicker
                id="startDateInput"
                placeholder="Starting on"
                disabled={this.props.disabled}
                value={this.state.selectedStartDateMoment}
                timeZone={this.state.selectedPool && this.state.selectedPool.timeZone ? this.state.selectedPool.timeZone : this.getRestaurantTimeZone()}
                onChange={date=>this.setState({selectedStartDateMoment: adjustScheduleStartTime(date)})}
                excludeDates={this.props.poolSchedule
                  .map(s=>moment.utc(s.startDateUtc).tz(this.getRestaurantTimeZone(s)))
                  .filter(m=>moment.utc().diff(m, 'days') !== 0)
                }
                minDate={this.minStartMoment(this.state.selectedPool)}
                maxDate={this.minStartMoment(this.state.selectedPool).add(1, 'year')}/>
            </div>

            <div className="col-sm-2">
              <button id="btnAdd" className="btn btn-primary" onClick={()=>this.addScheduleRow({})} disabled={!this.canAddScheduleRow()}>Add to pool</button>
            </div>
          </div>
        </div>
      }
    </div>
  }
}

PoolScheduleEditor.propTypes = {
  defaultTimeZone: PropTypes.string,
  savedPoolSchedule: PropTypes.array,
  poolSchedule: PropTypes.array,
  onPoolScheduleChange: PropTypes.func,
  isEditing: PropTypes.bool,
  disabled: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    defaultTimeZone : getDefaultTimezone(state)
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PoolScheduleEditor)



// WEBPACK FOOTER //
// ./src/containers/restaurants/details/poolScheduleEditor.js